import { FieldErrors } from 'react-hook-form';
import { BulkFilesUploadForm } from '../../../types';

export function getFormErrorMessage(errors: FieldErrors<BulkFilesUploadForm>) {
  if (errors.type?.message) {
    return errors.type.message;
  }

  if (errors.bulkImportType?.message) {
    return errors.bulkImportType.message;
  }

  if (
    errors.fileUploadIDs?.message &&
    errors.fileUploadIDs?.type === 'validate'
  ) {
    return errors.fileUploadIDs?.message;
  }

  if (errors.bulkUploadFiles?.message) {
    return errors.bulkUploadFiles?.message;
  }

  const bulkUploadFilesErrors =
    errors?.bulkUploadFiles
      ?.map?.((fieldError) => fieldError?.dataVendor?.message)
      .filter((error): error is string => Boolean(error)) ?? [];

  if (errors.bulkUploadFiles?.length && errors.bulkUploadFiles?.length > 0) {
    if (bulkUploadFilesErrors.length > 0) return bulkUploadFilesErrors.at(0);
    return;
  }
}
